import{isComponent as o}from"../Component/Component.js";var n=function(n){return o(n)};export{n as isC};
//# sourceMappingURL=C.js.map
